import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../modals/BaseModal";
import CustomCheckbox from "../../../custom-components/form-inputs/CustomCheckbox";
import AddSquareIconSVG from "../../shared/svg/AddSquareIconSVG";
import { ProductFeatureWithAccessedDTO } from "../../../domain/models/dto/ProductFeatureDTO";
import { roleServiceFactory } from "../../../services/RoleServiceImpl";
import { Role } from "../../../domain/models/Role";

interface RoleAddFeatureFormProps {
    role: Role;
}

const roleService = roleServiceFactory();

const RoleAddFeatureForm: FC<RoleAddFeatureFormProps> = (props) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [roleFeatures, setRoleFeatures] = useState<ProductFeatureWithAccessedDTO[]>([]);

    const confirmHandler = async () => {
        await roleService.patchRoleFeatures(props.role.id, roleFeatures);
        setIsVisible(false);
    };

    const closeHandler = () => {
        setRoleFeatures([]);
    };

    const onOpenHandler = async () => {
        const features = await roleService.getRolesFeatures(props.role.id);
        if (features) {
            setRoleFeatures(features);
        }
    };

    return (
        <BaseModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            title={`${t("console.roles.table.add")} '${props.role.name}'`}
            confirmTitle={t("console.common.apply")}
            cancelTitle={t("console.common.cancel")}
            buttonElement={
                <button
                    data-modal-target="static-modal"
                    data-modal-toggle="static-modal"
                    className="flex items-center justify-center text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-2.5 text-center max-h-10"
                    type="button"
                    title={t("console.roles.table.add")}
                    onClick={() => setIsVisible(true)}
                >
                    <AddSquareIconSVG className="w-[20px] fill-white" />
                </button>
            }
            confirmHandler={confirmHandler}
            closeHandler={closeHandler}
            onOpen={onOpenHandler}
            additionalWrapClassName="w-[450px]"
        >
            <form>
                {roleFeatures.map((feature) => (
                    <CustomCheckbox
                        key={`role-add-feature-${feature.id}`}
                        labelKey={feature.name}
                        checked={feature.accessed}
                        onClick={() => {
                            setRoleFeatures((prevState) =>
                                prevState.map((f) => (f.id === feature.id ? { ...f, accessed: !f.accessed } : f))
                            );
                        }}
                        className="mb-1"
                    />
                ))}
            </form>
        </BaseModal>
    );
};

export default RoleAddFeatureForm;